import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-play-circle-fill text-xl text-primary-500"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-950">
                好色tv
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              专注高清影视内容的正规视频平台，提供海量电影、电视剧、综艺及短视频资源。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <Link to="/category/dianying" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">电影</Link>
              <Link to="/category/dianshiju" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">电视剧</Link>
              <Link to="/category/zongyi" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">综艺</Link>
              <Link to="/category/duanshipin" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">短视频</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">
              关于我们
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">品牌介绍</Link>
              <a href="/about#reputation" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">企业荣誉</a>
              <a href="/about#contact" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">联系我们</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">
              联系方式
            </h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-500">
              <p>客服邮箱：kefu@haosetv.com</p>
              <p>商务合作：hezuo@haosetv.com</p>
              <p>客服热线：400-888-8888</p>
              <p>工作时间：周一至周日 9:00-21:00</p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 好色tv 版权所有 | ICP备案号：京ICP备2025000001号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}